import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '1252242806993118';
    const w = window as any;
    // Initialize fbq queue safely (no reliance on an existing <script> tag)
    if (!w.fbq) {
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      w.fbq = fbq;
      // Append the Meta Pixel script to <head> (guards against missing script tags)
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return null;
}